export default "__VITE_ASSET__BggVSYbx__"